import React from 'react';
import { Box, Heading, Body } from '@hover/blueprint';

const MHeading = () => (
  <Box d="block" textAlign="center" maxW="720px" mx="auto">
    <Heading
      mb={{ base: 2, desktop: 8 }}
      size={{ base: 400, tablet: 600, desktop: 700 }}
    >
      Manufacturers + Distributors
    </Heading>
    <Body size={600}>
      These partnerships help us connect the right materials, labor, and
      distributors with home improvement professionals and homeowners that need
      their services.
    </Body>
  </Box>
);

export default MHeading;
